import { render, staticRenderFns } from "./index.vue?vue&type=template&id=533d9145&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=533d9145&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=533d9145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d9145",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533d9145')) {
      api.createRecord('533d9145', component.options)
    } else {
      api.reload('533d9145', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=533d9145&scoped=true&", function () {
      api.rerender('533d9145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forgetPassword/index.vue"
export default component.exports